/**
 *
 * @module adEngineManagerExtrasMap
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';

/**
 *
 * @class AdEngineManagerExtrasMap
 * @desc Provides additional configuration information used by the manager.
 *
 */
export default class AdEngineManagerExtrasMap {

    /**
     *
     * @param {Object} adTargeting
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(adTargeting, logger = Logging) {

        const errorMessage = {
            ctor: 'AdEngineManagerExtrasMap(adTargeting, logger)',
            get adTargeting() {
                return `${this.ctor} adTargeting should be an Object`;
            }
        };

        if (Check.not.object(adTargeting)) {
            logger.warn('AdEngineManagerExtrasMap', errorMessage.adTargeting);
        }

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.adTargeting = adTargeting;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/adEngineManagerExtrasMap.js